import { Injectable, NgZone } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserActivityService {
  private activity$ = new Subject<void>();
  private timeoutMinutes = 15;   // ⏱ 15 minutes

  // throttleTime(1000) により mousemove 等の大量イベントを1秒に1回に間引く
  // 最後の notifyActivity() から timeoutMinutes 分後にタイムアウトを発火
  timeout$ = this.activity$.pipe(
    throttleTime(1000),
    switchMap(() => timer(this.timeoutMinutes * 60 * 1000))
  );

  constructor(private zone: NgZone) {}

  /** Call this on user activity */
  notifyActivity() {
    this.zone.runOutsideAngular(() => {
      this.activity$.next();
    });
  }

}
